// page.tsx
"use client";

import { useState, Suspense, lazy } from "react";
import LockScreen from "../../Components/Lockscreen";
import "./WhiteHouse.css";

import { WhiteHouseMail } from "./WhiteHouseAssets/WhiteHouseMailContent";
import { WhiteHouseNoteContent } from "./WhiteHouseAssets/WhiteHouseNoteContent";
import { WhiteHouseMessageContent } from "./WhiteHouseAssets/WhiteHouseMessagesContent";
import { WhiteHouseCallContent } from "./WhiteHouseAssets/WhiteHouseCallContent";
import { Chat_content } from "../../Components/MessageApp/MessagesInterfaces";
import { WhiteHouseTweetContent } from "./WhiteHouseAssets/WhiteHouseTweeterContent";
import CallApp from "../../Components/CallApp/CallApp";
import { ActivistPhotoContent } from "./WhiteHouseAssets/WhiteHousePhotoContent";
import InternetBanner from "./WhiteHouseAssets/WhiteHousePictures/Interner-Logo-01.webp";
import InternetArtical from "./WhiteHouseAssets/WhiteHousePictures/Interner-Photo.webp";
import InternetLogo from "./WhiteHouseAssets/WhiteHousePictures/Interner-Logo-02.webp";
import HomeIcon from "../../Components/Icons/HomeIcon";
import TheGramApp from "../../Components/TheGramApp/TheGramApp";
import { WhiteHouseTheGramContent } from "./WhiteHouseAssets/WhiteHouseGramContent";
import { SantaCamContent as WhiteHouseSantaCamContent } from "./WhiteHouseAssets/WhiteHouseSantaCamContent";

const Messages = lazy(() => import("../../Components/MessageApp/Messages"));
const Photos = lazy(() => import("../../Components/PhotosApp/Photos"));
const AppsMenu = lazy(
  () => import("../../Components/AppsMenu/AppsMenuWhiteHouse")
);
const NotesApp = lazy(() => import("../../Components/NotesApp/NotesApp"));
const TweeterApp = lazy(() => import("../../Components/TweeterApp/TweeterApp"));
const InternetApp = lazy(
  () =>
    import("../../Components/InternetApps/WhiteHouseInternetApp/InternetApp")
);
const MailApp = lazy(() => import("../../Components/MailApp/MailApp"));
const SantaPhotos = lazy(
  () => import("../../Components/SantaCamApp/SanataPhotos")
);

function WhiteHouse() {
  const [isLocked, setIsLocked] = useState(true);
  const [activeApp, setActiveApp] = useState("appsmenu");
  const [messages, setMessages] = useState(WhiteHouseMessageContent);
  const [messageNotifications, setMessageNotifications] = useState(0);

  const unlock = () => {
    setIsLocked(false);
  };

  const handleStateChange = (chat: Chat_content) => {
    const chatIndex = messages.findIndex(
      (message) => message.name === chat.name
    );
    const previousMessage = messages[chatIndex];
    if (previousMessage && !previousMessage.read) {
      const newMessages = [...messages];
      newMessages[chatIndex] = {
        ...newMessages[chatIndex],
        read: true,
      };
      setMessages(newMessages);
      setMessageNotifications(messageNotifications - 1);
    }
  };

  const renderApp = () => {
    switch (activeApp) {
      case "messages":
        return (
          <Messages
            influencerMessageContent={messages}
            theGram={false}
            handleStateChange={handleStateChange}
          />
        );
      case "phone":
        return <CallApp callContent={WhiteHouseCallContent} />;
      case "photos":
        return <Photos albums={ActivistPhotoContent} />;
      case "notes":
        return <NotesApp noteContent={WhiteHouseNoteContent} />;
      case "appsmenu":
        return (
          <AppsMenu
            isLocked={isLocked}
            setActiveApp={setActiveApp}
            messageNotifications={messageNotifications}
          />
        );
      case "tweeter":
        return <TweeterApp tweeterContent={WhiteHouseTweetContent} />;
      case "mail":
        return <MailApp emails={WhiteHouseMail} />;
      case "thegram":
        return (
          <TheGramApp content={WhiteHouseTheGramContent} notifications={0} />
        );
      case "santaCam":
        return <SantaPhotos Photos={WhiteHouseSantaCamContent} />;

      case "internet":
        return (
          <InternetApp
            headerImage={InternetBanner}
            bodyImage={InternetArtical}
            logoIcon={InternetLogo}
            searchBarText="Hasina Jafari Mwanga"
            articleTitle="Hasina Jafari Mwanga"
            articleDate=""
            author="President of Tanzania"
            photoCaption="via Betty images"
            bodyText="President of Tanzania"
            website=""
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="Mystery">
      <div className="phone-wrapper">
        <div className={`WhiteHousescreen ${activeApp}`}>
          {isLocked ? (
            <div
              className={`lockscreen-container ${
                isLocked ? "visible" : "hidden"
              }`}
            >
              <LockScreen unlock={unlock} password="519212" />
            </div>
          ) : null}

          <Suspense
            fallback={
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                Loading...
              </div>
            }
          >
            {renderApp()}
          </Suspense>
          <div className="home-button-container">
            <HomeIcon onClick={() => setActiveApp("appsmenu")} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default WhiteHouse;
